import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../../../../../components/LazyWidgets/Tooltip';

import styles from './SRLKeyNumber.module.css';

const LIMIT_CHARACTERS_LABEL = 66;

const renderPostscript = (postScript) => {
  if (postScript) {
    return (
      <span> {postScript} </span>
    );
  }
  return null;
};

function SRLKeyNumber({ keyNumber, postScript, label, smallFontSize }) {
  return (
    <div className={styles.keyNumberContainer}>
      <div>
        <div className={`${styles.value} ${smallFontSize && styles.smallFontSize}`}>
          {isNaN(keyNumber) && '--'}
          {!isNaN(keyNumber) && keyNumber}
        </div>
        {!isNaN(keyNumber) && renderPostscript(postScript)}
      </div>

      {label && label.length >= LIMIT_CHARACTERS_LABEL && (
        <Tooltip
          trigger={<div className={styles.preventOverflow}> {label} </div>}
          content={label}
          on="hover"
        />
      )}

      {(!label || !label.length || label.length < LIMIT_CHARACTERS_LABEL) && (
        <div className={`${smallFontSize && styles.labelSmall}`}>
          {label}
        </div>
      )}
    </div>
  );
}

SRLKeyNumber.propTypes = {
  keyNumber: PropTypes.number,
  postScript: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  label: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.elementType
  ]),
  smallFontSize: PropTypes.bool,
};

export default SRLKeyNumber;
